import { L10n, createElement, isNullOrUndefined } from '@syncfusion/ej2-base';
import { Calendar } from '@syncfusion/ej2-calendars';
/**
 * The DateContent dialog is used to display calendar
 */
export class DatePickerDialog {
    /**
     * @param {DocumentHelper} documentHelper - Specifies the document helper
     * @private
     */
    constructor(documentHelper) {
        /**
         * @private
         * @returns {void}
         */
        this.onCancelButtonClick = () => {
            this.documentHelper.dialog.hide();
            this.documentHelper.updateFocus();
        };
        this.documentHelper = documentHelper;
    }
    getModuleName() {
        return 'DateContentDialog';
    }
    /**
     * @private
     * @param {L10n} localValue - Specified the locale value.
     * @returns {void}
     */
    initDateContentDialog(localValue) {
        this.target = createElement('div');
        this.parentDiv = createElement('div');
        this.target.appendChild(this.parentDiv);
        const calendar = new Calendar({
            change: this.valueChange.bind(this)
        });
        this.calendar = calendar;
        if (this.documentHelper.owner.editor.dateValue) {
            calendar.value = new Date(this.documentHelper.owner.editor.dateValue);
        }
        calendar.appendTo(this.parentDiv);
        if (this.documentHelper.owner.editor.dateValue) {
            calendar.value = new Date(this.documentHelper.owner.editor.dateValue);
        }
        //parentDiv.append(calendar);
    }
    valueChange(args) {
        if (args.event) {
            const value = args.value.toLocaleDateString();
            const contenControl = this.documentHelper.owner.selection.currentContentControl;
            this.documentHelper.owner.editor.dropDownChange(contenControl, value);
            this.documentHelper.hideDialog();
            if (this.calendar) {
                this.calendar.value = null;
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    show() {
        const localValue = new L10n('documenteditor', this.documentHelper.owner.defaultLocale);
        localValue.setLocale(this.documentHelper.owner.locale);
        this.localeValue = localValue;
        if (!this.target) {
            this.initDateContentDialog(localValue);
        }
        if (this.documentHelper.selection.caret.style.display !== 'none') {
            this.documentHelper.selection.caret.style.display = 'none';
        }
        this.documentHelper.dialog.header = localValue.getConstant('Datepicker Content Control');
        this.documentHelper.dialog.height = 'auto';
        this.documentHelper.dialog.width = 'auto';
        this.documentHelper.dialog.content = this.target;
        this.documentHelper.dialog.beforeOpen = this.documentHelper.updateFocus;
        this.documentHelper.dialog.close = this.documentHelper.updateFocus;
        this.documentHelper.dialog.dataBind();
        this.documentHelper.dialog.show();
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        if (this.calendar) {
            this.calendar.destroy();
            this.calendar = undefined;
        }
        this.documentHelper = undefined;
        if (this.parentDiv) {
            this.parentDiv.remove();
            this.parentDiv = undefined;
        }
        if (!isNullOrUndefined(this.target)) {
            if (this.target.parentElement) {
                this.target.parentElement.removeChild(this.target);
            }
            for (let i = 0; i < this.target.childNodes.length; i++) {
                this.target.removeChild(this.target.childNodes[parseInt(i.toString(), 10)]);
                i--;
            }
            this.target = undefined;
        }
    }
}
